import { ChatIcon, CloseIcon } from '@chakra-ui/icons';
import { Box, Flex, IconButton, Text } from '@chakra-ui/react';
import CockpitAssistChat from 'components/CockpitAssistChat';
import PropTypes from 'prop-types';
import { useState } from 'react';
import '../../pages/Cockpit/QuickCashflowModel/quickCashflow.scss';

function CockpitAssistFab({
  onSend,
  isVisible,
  title = 'AI Assistant',
  subtitle,
  placeholder,
  disabled,
  initialMessages,
}) {
  const [open, setOpen] = useState(false);

  if (!isVisible) {
    return null;
  }

  return (
    <>
      {open ? (
        <Box
          position="fixed"
          inset={0}
          zIndex={1199}
          onClick={() => setOpen(false)}
        />
      ) : null}
      <Box
        position="fixed"
        bottom="88px"
        right="24px"
        width="380px"
        maxH="70vh"
        zIndex={1200}
        bg="white"
        borderRadius="lg"
        boxShadow="0 8px 32px rgba(46, 47, 102, 0.18)"
        border="1px solid"
        borderColor="gray.200"
        display={open ? 'flex' : 'none'}
        flexDirection="column"
        overflow="hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <Flex
          align="center"
          justify="space-between"
          px={4}
          py={3}
          borderBottom="1px solid"
          borderColor="gray.100"
          bg="purple.50"
          flexShrink={0}
        >
          <Box>
            <Text fontWeight="semibold" fontSize="sm">
              {title}
            </Text>
            {subtitle ? (
              <Text fontSize="xs" color="gray.500">
                {subtitle}
              </Text>
            ) : null}
          </Box>
          <IconButton
            aria-label="Close AI assistant"
            icon={<CloseIcon boxSize={3} />}
            size="sm"
            variant="ghost"
            onClick={() => setOpen(false)}
          />
        </Flex>
        <Box flex={1} overflow="hidden" p={4} className="quick-cashflow-page">
          <CockpitAssistChat
            onSend={onSend}
            placeholder={placeholder}
            disabled={disabled}
            maxHeight="calc(70vh - 160px)"
            initialMessages={initialMessages}
          />
        </Box>
      </Box>
      <IconButton
        aria-label={open ? 'Close AI assistant' : 'Open AI assistant'}
        icon={open ? <CloseIcon /> : <ChatIcon />}
        colorScheme="purple"
        size="lg"
        isRound
        position="fixed"
        bottom="24px"
        right="24px"
        zIndex={1200}
        boxShadow="lg"
        onClick={() => setOpen((v) => !v)}
      />
    </>
  );
}

CockpitAssistFab.propTypes = {
  onSend: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  initialMessages: PropTypes.array,
};

export default CockpitAssistFab;
